import { useEffect } from 'react'
import { v4 as uuid } from 'uuid'
import { createPlaceholderForElement } from '../utils/createPlaceholderForElement'

export const useHandleIframe = (content: string) => {
  useEffect(() => {
    const iframes = new Map<string, Element>()

    const intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const target = entry.target as HTMLElement

            const iframe = iframes.get(target.id)
            if (!iframe) return

            target.parentNode?.replaceChild(iframe, target)
            iframes.delete(target.id)
            intersectionObserver.unobserve(target)
          }
        })
      },
      {
        threshold: 0.1,
        rootMargin: '100px 0px 0px 0px',
      },
    )

    /**
     * Iframes inside "Raw HTML" plugin may use scrollIntoView function whill will
     * cause the page to scroll to the iframe. To prevent this, we replace
     * iframe with a div placeholder until the placeholder is in view.
     * This will prevent the page from scrolling to the iframe at the start.
     *
     * Iframes inside "Embed" plugin does not have any scrollIntoView function usage.
     * So, we don't need to replace them with a placeholder.
     */
    document.querySelectorAll('div.raw iframe').forEach((iframe) => {
      const id = uuid()
      iframes.set(id, iframe)

      const placeholder = createPlaceholderForElement(iframe)
      placeholder.id = id

      iframe.parentNode?.replaceChild(placeholder, iframe)
      intersectionObserver.observe(placeholder)
    })

    return () => {
      intersectionObserver.disconnect()
    }
  }, [content])
}
